export const validLinkedInId = (value: string) => {
  return value.match(/^[0-9]+$/) && value.length < 12 && parseInt(value) > 0
}

export const linkedInCompanyUrl = (linkedinId: string) => {
  return linkedinId ? `https://www.linkedin.com/company/${linkedinId}` : null
}
